/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import config from "../config/reInviteUser.config.json";
import notification from "../config/notifications.config.json";
import { VApplication } from "../../../application";
import { AppNavigatorService } from "../../appNavigatorService";
import { GET_MASQUERADER_COUNT } from "../graphql/getUserAdvancedSearchBox.query";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";

import axios from "axios";
import { GET_FEATURE_FIELDS } from "../graphql";

export interface IFeaturesFieldsUserMethods extends IPluginMethodMap {
  getFeaturesFields(args: any): Promise<any>;
}

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

const LoginPageServ = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.AppNavigatorService") as AppNavigatorService;
};

export class FeaturesFieldsUserService implements IAgentPlugin {
  readonly methods: IFeaturesFieldsUserMethods;

  constructor() {
    this.methods = {
      getFeaturesFields: this.getFeaturesFields.bind(this),
    };
  }

  async getFeaturesFields(args: any) {
    const graphqlModule = getGraphQLModule();
    const client = graphqlModule.getClient("graphql-gateway");
    const srv = LoginPageServ();
    console.log(args);
    let variables = {};
    if (args?.presentation) {
      variables = {
        ...variables,
        presentation: {
          eq: args?.presentation,
        },
      };
    }
    if (args?.section) {
      variables = {
        ...variables,
        section: {
          eq: args?.section,
        },
      };
    }
    if (args?.costumeType) {
      variables = {
        ...variables,
        costumeType: {
          eq: args?.costumeType,
        },
      };
    }
    try {
      const res = await client.query({
        query: GET_FEATURE_FIELDS,
        variables: {
          filter: variables,
        },
        fetchPolicy: "network-only",
      });
      if (res?.data) {
        // const fields = res?.data?.getMasqReportFields;

        // const formatted = {
        //   features: fields?.FeatureFields.map((item: any) => ({
        //     label: item,
        //     value: item,
        //   })),
        //   mainfields: fields?.MainField.map((item: any) => ({
        //     label: item,
        //     value: item,
        //   })),
        // };
        const fields = res?.data?.getMasqReportFields;

        const featureMap: Record<string, { id: string; label: string }[]> = {};
        const featureList: { id: string; label: string }[] = [];

        fields?.FeatureFields?.forEach((feature: any) => {
          if (feature?.featureName && Array.isArray(feature.attributes)) {
            featureMap[feature.featureName] = feature.attributes.map(
              (attr: string) => ({
                id: attr,
                label: attr,
              })
            );
            featureList.push({
              id: feature.featureName,
              label: feature.featureName,
            });
          }
        });

        const formatted = {
          mainfields: fields?.MainField?.map((item: string) => ({
            label: item,
            value: item,
          })),
          featuresMap: featureList, // [{ id: "Sleeves", label: "Sleeves" }, ...]
          features: featureMap, // { "Sleeves": [ { id: "...", label: "..." } ], ... }
        };

        console.log(formatted);

        return formatted;
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }
}

// {
//       "type": "multiSelect",
//       "compProps": {
//         "id": "mainfields",
//         "label": "Select Fields",
//         "required": true,
//         "placeholder": "Choose the required fields",
//         "errorText": "At least one field must be selected",
//         "options": []
//       }
//     },
//     {
//       "type": "multiSelect",
//       "compProps": {
//         "id": "features",
//         "label": "Select Features",
//         "required": true,
//         "placeholder": "Choose the required Features",
//         "errorText": "At least one feature must be selected",
//         "options": []
//       }
//     }
